import OptionCard from './OptionCard';
import QuestionCard from './QuestionCard';

/**
 * Groups options: if options share an option_group they are rendered as radio-group.
 * Standalone options render as checkboxes.
 * Non-standard input_type options render as QuestionCard (questionnaire fields).
 */
export default function OptionGroup({ options }) {
    if (!options || options.length === 0) return null;

    // Separate questionnaire-style options from standard options.
    const standardOptions = [];
    const questionOptions = [];

    options.forEach((opt) => {
        const inputType = opt.input_type || 'standard';
        if (inputType !== 'standard') {
            questionOptions.push(opt);
        } else {
            standardOptions.push(opt);
        }
    });

    // Group standard options by option_group.
    const groups = {};
    const ungrouped = [];

    standardOptions.forEach((opt) => {
        if (opt.option_group) {
            if (!groups[opt.option_group]) {
                groups[opt.option_group] = [];
            }
            groups[opt.option_group].push(opt);
        } else {
            ungrouped.push(opt);
        }
    });

    return (
        <div className="ast-option-group">
            {/* Render questionnaire-style options first. */}
            {questionOptions.length > 0 && (
                <div className="ast-qcard-list">
                    {questionOptions.map((opt) => (
                        <QuestionCard key={opt.id} option={opt} />
                    ))}
                </div>
            )}

            {/* Render grouped standard options with a visual label. */}
            {Object.entries(groups).map(([groupName, groupOpts]) => (
                <div key={groupName} className="ast-option-group__section">
                    <h5 className="ast-option-group__label">
                        {groupName.charAt(0).toUpperCase() + groupName.slice(1).replace(/_/g, ' ')}
                    </h5>
                    <div className="ast-option-grid ast-option-grid--radio">
                        {groupOpts.map((opt) => (
                            <OptionCard key={opt.id} option={opt} />
                        ))}
                    </div>
                </div>
            ))}

            {/* Render ungrouped standard options. */}
            {ungrouped.length > 0 && (
                <div className="ast-option-grid">
                    {ungrouped.map((opt) => (
                        <OptionCard key={opt.id} option={opt} />
                    ))}
                </div>
            )}
        </div>
    );
}
